import { createSelector } from 'reselect';
import { RootState } from '../reducer';
import { building } from '../building/selectors';
import { initialSettingsState } from './reducer';

export const buildingSettingsByBuildingState = (state: RootState) => state.buildingSettings;

export const buildingUuidSelector = createSelector(building, (b) => b?.uuid);

export const buildingSettingsSelector = createSelector(
  [buildingUuidSelector, buildingSettingsByBuildingState],
  (buildingUuid, settingsByBuilding) => settingsByBuilding?.[buildingUuid] ?? initialSettingsState,
);

export const buildingSettingsByUuidSelector = (buildingUuid: string) =>
  createSelector(
    [buildingSettingsByBuildingState],
    (settingsByBuilding) => settingsByBuilding?.[buildingUuid] ?? initialSettingsState,
  );

export const buildingSettingsLoadingByUuidSelector = (buildingUuid: string) =>
  createSelector(
    [buildingSettingsByUuidSelector(buildingUuid)],
    (buildingSettings) => buildingSettings?.loading ?? false,
  );

export const selectAvailableCheckInOptionsByUuidSelector = (buildingUuid: string) =>
  createSelector(
    [buildingSettingsByUuidSelector(buildingUuid)],
    (buildingSettings) => buildingSettings?.settings?.availableCheckInOptions ?? null,
  );

export const selectTenantOverridesByUuidSelector = (buildingUuid: string) =>
  createSelector(
    [buildingSettingsByUuidSelector(buildingUuid)],
    (buildingSettings) => buildingSettings?.settings?.tenantOverrides ?? [],
  );

export const selectDefaultCheckInOptionByUuidSelector = (buildingUuid: string) =>
  createSelector(
    [buildingSettingsByUuidSelector(buildingUuid)],
    (buildingSettings) => buildingSettings?.settings?.defaultCheckInOption ?? null,
  );
